const countries = [
  'de'/*,
  'at'*/
];

export default countries;
